import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

import { SectionContainer } from 'components/shared';
import { ClientUserDTO } from 'interfaces';

import styles from './ClientDetailsData.module.css';

export const ClientDetailsData = (client: ClientUserDTO) => {
   const { t } = useTranslation();
   return (
      <>
         <SectionContainer style={{ marginTop: 24 }} title={t('clientDetails.section.basicData')}>
            <div className={styles.row}>
               <p className={styles.label}>{t('clients.table.nip')}</p>
               <p>{client.nip}</p>
            </div>
            <div className={styles.row}>
               <p className={styles.label}>{t('supplier_orders.table.client_name')}</p>
               <p>{client.companyName}</p>
            </div>
            <div className={styles.row}>
               <p className={styles.label}>{t('distribution_center.street')}</p>
               <p>{client.address}</p>
            </div>
            <div className={classNames(styles.row, styles.flex)}>
               <div>
                  <p className={styles.label}>{t('distribution_center.zip')}</p>
                  <p>{client.zipCode}</p>
               </div>
               <div>
                  <p className={styles.label}>{t('distribution_center.city')}</p>
                  <p>{client.city}</p>
               </div>
            </div>
         </SectionContainer>
         <SectionContainer title={t('clientDetails.section.contactData')}>
            <div className={styles.row}>
               <p className={styles.label}>{t('sent_password_reset.phone')}</p>
               <p>{client.phoneNumber}</p>
            </div>
            <div className={styles.row}>
               <p className={styles.label}>{t('clientDetails.label.invoiceEmail')}</p>
               <p>{client.invoiceEmail}</p>
            </div>
            <div className={styles.row}>
               <p className={styles.label}>{t('clientDetails.label.contactEmail')}</p>
               <p>{client.email}</p>
            </div>
         </SectionContainer>
         <SectionContainer title={t('clientDetails.section.deliveryAddresses')}>
            {client.deliveryAddresses.map((deliveryAddress, index) => {
               const { address, zipCode, city, name } = deliveryAddress.address;
               return (
                  <div key={index}>
                     <h3 className={styles.addressTitle}>
                        {t('clientDetails.label.addressIndex', { index: index + 1 })}
                     </h3>
                     <div className={styles.row}>
                        <p className={styles.label}>{t('clientDetails.label.name')}</p>
                        <p>{name}</p>
                     </div>
                     <div className={styles.row}>
                        <p className={styles.label}>{t('distribution_center.street')}</p>
                        <p>{address}</p>
                     </div>
                     <div className={classNames(styles.row, styles.flex)}>
                        <div>
                           <p className={styles.label}>{t('distribution_center.zip')}</p>
                           <p>{zipCode}</p>
                        </div>
                        <div>
                           <p className={styles.label}>{t('distribution_center.city')}</p>
                           <p>{city}</p>
                        </div>
                     </div>
                  </div>
               );
            })}
         </SectionContainer>
      </>
   );
};
